import type { NavigateFunction } from 'react-router-dom'

export const redirect = (navigate: NavigateFunction, path: string): void => {
  navigate(path)
}
